import InviteHeader from "pages/PanelPage/components/selectedAssessment/assessmentInvite/InviteHeader/InviteHeader";

export default InviteHeader;
